// Car single-page lead CTA - phone + consent → admin-ajax (atpl_lead_submit).
import { qs, qsa, on, trimFields } from '../lib/dom.js';
import { t } from '../lib/i18n.js';

export function initLeadCta() {
  qsa('[data-component="lead-cta"]').forEach((root) => {
    const form = qs('form', root);
    const ajax = root.dataset.ajax;
    const status = qs('[data-role="lead-status"]', root);
    // Optional success-confirmation block (e.g. the offer modal). When present,
    // on success we hide the form and reveal this checkmark + message block.
    const done = qs('[data-role="lead-done"]', root);
    const doneMsg = done ? qs('[data-role="lead-done-msg"]', done) : null;
    if (!form || !ajax) return;

    const setStatus = (msg, ok) => {
      if (!status) return;
      status.hidden = false;
      status.textContent = msg;
      status.classList.toggle('is-ok', !!ok);
      status.classList.toggle('is-error', !ok);
    };

    on(form, 'submit', async (e) => {
      e.preventDefault();
      const phone = qs('[name="phone"]', form);
      const consent = qs('[name="consent"]', form);

      // See trimFields(): `required` accepts a lone Space, so normalise first.
      trimFields(form);

      if (!form.checkValidity()) {
        if (phone && !phone.value.trim()) { phone.classList.add('is-error'); phone.focus(); }
        const consentMissing = consent && !consent.checked;
        if (consentMissing) {
          const wrap = consent.closest('.ap-checkbox');
          if (wrap) wrap.classList.add('is-error');
        }
        // Name/phone problems already have their own message under the field
        // (lead-validate.js), so the status line only adds the consent hint.
        const fieldErr = qs('.ap-input-error:not([hidden])', root);
        if (fieldErr && !consentMissing) {
          if (status) status.hidden = true;
        } else {
          setStatus(fieldErr
            ? t('form_check_data', 'Verifică datele și încearcă iar.')
            : t('lead_need_phone', 'Adaugă numărul de telefon și bifează acordul.'), false);
        }
        return;
      }

      const btn = qs('button[type="submit"]', form);
      if (btn) btn.classList.add('is-loading');
      try {
        const res = await fetch(ajax, {
          method: 'POST',
          credentials: 'same-origin',
          body: new FormData(form),
        });
        const data = await res.json().catch(() => null);
        if (data && data.success) {
          form.reset();
          const msg = (data.data && data.data.message) || t('lead_thanks', 'Mulțumim! Te sunăm în scurt timp.');
          if (done) {
            // Confirmation mode: collapse the modal down to just the success
            // block. `is-submitted` (CSS) hides the header text + form so only
            // the confirmation message and the close button remain visible.
            form.hidden = true;
            if (doneMsg) doneMsg.textContent = msg;
            done.hidden = false;
            root.classList.add('is-submitted');
          } else {
            setStatus(msg, true);
          }
        } else {
          setStatus((data && data.data && data.data.message) || t('error_retry', 'A apărut o eroare. Încearcă din nou.'), false);
        }
      } catch {
        setStatus(t('lead_conn_failed', 'Conexiune eșuată. Încearcă din nou.'), false);
      } finally {
        if (btn) btn.classList.remove('is-loading');
      }
    });

    // Clear error states as the user fixes them.
    on(form, 'input', (e) => {
      if (e.target.classList && e.target.classList.contains('is-error') && e.target.checkValidity()) {
        e.target.classList.remove('is-error');
      }
    });
    on(form, 'change', (e) => {
      if (e.target.name === 'consent' && e.target.checked) {
        const wrap = e.target.closest('.ap-checkbox');
        if (wrap) wrap.classList.remove('is-error');
      }
    });
  });
}
